export const tagTypes = {
    end: 0,
    byte: 1,
    short: 2,
    int: 3,
    long: 4,
    float: 5,
    double: 6,
    byteArray: 7,
    string: 8,
    list: 9,
    compound: 10,
    intArray: 11,
    longArray: 12,
};
export const tagNames = [
    'end',
    'byte',
    'short',
    'int',
    'long',
    'float',
    'double',
    'byteArray',
    'string',
    'list',
    'compound',
    'intArray',
    'longArray',
];
//# sourceMappingURL=Tags.js.map